;
(function(window){
    window.loadReviews = (function() {
    var $button, originalText;
    var handleLoad = function(data, data12, data2) {
        if ( $button ) $button.text(originalText);
        var nElementCount = $('.sample__review').length;
        if ( elementCount == nElementCount ) {
        // No more left
        $('.sample__reviews > p').remove();
        } else {
        enabled = true;
        }
        elementCount = nElementCount;
    }
    var elementCount = $('.sample__review').length;
    var enabled = true;
    var page = 1;
    return function(sender, slug) {
        $button = $(sender);
        originalText = $button.text();
        if ( enabled ) {
        $button.text('Loading...');
        $('<div>').load('/' + slug + '?page=' + (++page) + ' .sample__review', handleLoad).insertBefore($('.sample__reviews > p'));
        }
        enabled = false;
    };
    })();
})(window);